/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_MessageInputs */

const en_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your message *`)
};

const es_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu mensaje *`)
};

const fr_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre message *`)
};

const de_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Nachricht *`)
};

const ja_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージ *`)
};

const zh_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的留言 *`)
};

const ar_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رسالتك *`)
};

const id_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Anda *`)
};

const it_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo messaggio *`)
};

const ru_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваше сообщение *`)
};

const pt_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua mensagem *`)
};

const ko_your_message = /** @type {(inputs: Your_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지 *`)
};

/**
* | output |
* | --- |
* | "Your message *" |
*
* @param {Your_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_message = /** @type {((inputs?: Your_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_message(inputs)
	if (locale === "es") return es_your_message(inputs)
	if (locale === "fr") return fr_your_message(inputs)
	if (locale === "de") return de_your_message(inputs)
	if (locale === "ja") return ja_your_message(inputs)
	if (locale === "zh") return zh_your_message(inputs)
	if (locale === "ar") return ar_your_message(inputs)
	if (locale === "id") return id_your_message(inputs)
	if (locale === "it") return it_your_message(inputs)
	if (locale === "ru") return ru_your_message(inputs)
	if (locale === "pt") return pt_your_message(inputs)
	return ko_your_message(inputs)
});